import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MovementsDetailModel } from '../../../tyres/models/movements-detail.model';
import { Utilities } from '../../utilities/utilities.model';
import { TyresMovementStatusService } from '@shared/service/tyres-movement-status.service';
import { TyresCommoditiesService } from '@shared/service/tyres-commodities.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-tyres-mat-chip-status',
    templateUrl: './tyres-mat-chip-status.component.html',
})
export class TyresMatChipStatusComponent implements OnInit, OnChanges {

    @Input() movement: MovementsDetailModel;

    value = '';
    currentStatus: string;
	translateContext: TranslateContext = TranslateContext.TYRES;

    constructor(public tyresMovementsStatusService: TyresMovementStatusService,
        public tyreCommodities: TyresCommoditiesService) {
    }

    ngOnInit(): void {
        this.tyresMovementsStatusService.currentStatusKey$.subscribe(status => {
            this.currentStatus = status;
            this.value = this.tyresMovementsStatusService.getStatusName();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!Utilities.isVoid(changes) && !Utilities.isVoid(changes.movement)) {
            this.tyresMovementsStatusService = new TyresMovementStatusService(this.tyreCommodities);
            this.tyresMovementsStatusService.currentStatusKey$.subscribe(status => {
                this.currentStatus = status;
                this.value = this.tyresMovementsStatusService.getStatusName();
            });
            this.tyresMovementsStatusService.setMovement(this.movement);
        }
    }

}
